import { render, staticRenderFns } from "./BespokeService.vue?vue&type=template&id=3b0be0a6"
import script from "./BespokeService.vue?vue&type=script&lang=js"
export * from "./BespokeService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports